module.exports = __webpack_public_path__ + "media/images/gallery/stars/orion/bellatrix_vis-2164085e947d35968be8d4fed41d11c0.jpg";